import Cookies from "js-cookie";
import { axiosInstance, NOTIFICATION_URL } from "../apiurls/apiurls";

export const getNotifications = () => {
  const token = Cookies.get("accessToken");
  if (!token) {
    return Promise.resolve(null);
  }
  return new Promise((resolve, reject) => {
    try {
      const socket = new WebSocket(NOTIFICATION_URL);

      socket.onopen = () => {
        try {
          const token = Cookies.get("accessToken");
          if (token) {
            socket.send(
              JSON.stringify({
                token,
              }),
            );
          }
        } catch (e) {
          console.error("Failed to read token for notifications", e);
        }
      };

      socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          resolve(data);
        } catch (e) {
          resolve(event.data);
        } finally {
          socket.close();
        }
      };

      socket.onerror = (error) => {
        if (
          socket.readyState === WebSocket.OPEN ||
          socket.readyState === WebSocket.CONNECTING
        ) {
          console.warn("Notification WebSocket error:", error);
        }
        reject(error);
      };

      socket.onclose = () => {};
    } catch (error) {
      reject(error);
    }
  });
};

export const createNotificationsSocket = (onMessage, onError) => {
  const token = Cookies.get("accessToken");
  if (!token) {
    return null;
  }
  try {
    const socket = new WebSocket(NOTIFICATION_URL);

    socket.onopen = () => {
      try {
        const token = Cookies.get("accessToken");
        if (token) {
          socket.send(
            JSON.stringify({
              token,
            }),
          );
        }
      } catch (e) {
        console.error("Failed to read token for notifications", e);
      }
    };

    socket.onmessage = (event) => {
      let payload = event.data;
      try {
        payload = JSON.parse(event.data);
      } catch (e) {
        console.error(e);
      }

      if (typeof onMessage === "function") {
        onMessage(payload);
      }
    };

    socket.onerror = (error) => {
      if (
        socket.readyState === WebSocket.OPEN ||
        socket.readyState === WebSocket.CONNECTING
      ) {
        console.warn("Notification WebSocket connection issue:", error);
      }
      if (typeof onError === "function") {
        onError(error);
      }
    };

    return socket;
  } catch (error) {
    console.error("Failed to create notifications WebSocket:", error);
    if (typeof onError === "function") {
      onError(error);
    }
    return null;
  }
};

export const markNotificationAsRead = async (notificationId) => {
  if (!notificationId) return;

  try {
    const response = await axiosInstance.put(
      "/api/users/notification/markasread/update",
      null,
      {
        params: { notification_id: notificationId },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error marking notification as read:", error);
    throw error;
  }
};
